import { ToolTip } from 'src/components/atoms/ToolTip';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  & .bottom_fit {
    right: -1.25rem;
  }
`;
export const StyledToolTip = styled(ToolTip)`
  width: 20px;
`;
